import { statusTag } from '@/features/common/statusTag';
import {
  EVENT_MARKER_LABEL,
  EVENT_MARKER_VARIANT,
  eventMarker,
} from '@/features/publicsite/events/eventStatus';
import type { EventMarkerBadgeProps } from '@/features/publicsite/types/events/EventMarkerBadgeProps';
import { publicEvents } from '@/i18n/dictionaries/publicEvents';
import { useTranslation } from '@/i18n/useTranslation';

/** „Anulat” or „Încheiat” on a calendar card and an event page — the same badge in both places. */
export function EventMarkerBadge({ event, className }: EventMarkerBadgeProps) {
  const { t } = useTranslation(publicEvents);
  const marker = eventMarker(event);
  if (!marker) return null;
  return (
    <span
      className={`${statusTag(EVENT_MARKER_VARIANT[marker])}${className ? ` ${className}` : ''}`}
    >
      {t(EVENT_MARKER_LABEL[marker])}
    </span>
  );
}
